import { isPresent } from '@/lib/utils';

const interpolate = ({ label, args }) => {
  if (!args) return label;
  let interpolatedLabel = label;
  for (let i = 0; i < args.length; i += 1) {
    const re = new RegExp(`\\{${i}\\}`, 'g');
    interpolatedLabel = interpolatedLabel.replace(re, args[i]);
  }
  return interpolatedLabel;
};

const evaluateString = (translations, lookup, message, args) => {
  let translated = translations[lookup][message] || message;
  if (translated && translated.match(/{\d+}/)) translated = interpolate({ label: translated, args });
  return translated;
};

// Referenced from Flex's TransferObject.as
const translateMessage = ({ errors, labels }, arr) => {
  let message = arr?.[0];
  let lookupFrom = 'errors';
  let args;

  if (isPresent(message)) message = String(message);
  if (!message) return '[Unspecified]';

  // If wrapped in { }, attempt translation lookup
  if (message[0] === '{') {
    if (arr.length > 1 && arr[1]) {
      // Recursively translate argument message arrays
      args = arr[1].map(i => translateMessage({ errors, labels }, i));
    }

    // Determine lookup source and strip wrapping syntax
    if (message.endsWith('}')) {
      message = message.slice(1, -1);
    } else if (message.endsWith('}l')) {
      message = message.slice(1, -2);
      lookupFrom = 'labels';
    } else {
      message = message.slice(1);
    }

    // Perform label lookup and interpolation
    const lookup = evaluateString({ errors, labels }, lookupFrom, message, args);

    // Fallback if lookup fails
    if (!lookup) {
      message = message || `{Unspecified ${lookupFrom.slice(0, -1)}`;
    } else {
      message = lookup;
    }
  }

  return message;
};

const localState = {
  errors: {},
  labels: {},
};

const localGetters = {
  // REFACTOR: Combine error and label getters
  error: state => (translatable, params) => {
    if (!isPresent(translatable)) return '';
    if (!Array.isArray(translatable)) {
      translatable = [translatable];
      if (params) translatable.push([params]);
    }
    return translateMessage(state, translatable);
  },

  label: state => (translatable, params) => {
    if (!isPresent(translatable)) return '';
    if (!Array.isArray(translatable)) {
      translatable = [translatable];
      if (params) translatable.push([params]);
    }
    return translateMessage(state, translatable);
  },

  labels: state => {
    return state.labels;
  },

  rawTranslate: state => key => {
    return state.labels[key] || state.errors[key] || key;
  },
};

const localActions = {
  initializeTranslations({ commit }, translations) {
    commit('setTranslations', translations);
  },
};

const localMutations = {
  setTranslations(state, translations) {
    function objectify(text) {
      const retval = {};
      if (!text) return retval;
      const textLines = text.split('\n');
      textLines.forEach(element => {
        if (element[0] === '#') return;
        const index = element.indexOf('=');
        element = [element.slice(0, index), element.slice(index + 1, element.length)];
        if (element.length > 1) {
          retval[element[0]] = element[1];
        }
      });
      return retval;
    }
    state.errors = objectify(translations.errors);
    state.labels = objectify(translations.labels);
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
